module.exports = __webpack_public_path__ + "static/rumba (4)-576c2a722836acbd517180b7ec33c225.jpg";